var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 16C15.2061 16 17.0001 14.206 17.0001 12C17.0001 9.794 15.2061 8 13.0001 8C10.7941 8 9.00009 9.794 9.00009 12C9.00009 14.206 10.7941 16 13.0001 16ZM13.0001 10C14.1031 10 15.0001 10.897 15.0001 12C15.0001 13.103 14.1031 14 13.0001 14C11.8971 14 11.0001 13.103 11.0001 12C11.0001 10.897 11.8971 10 13.0001 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4201 23.814C12.5894 23.9346 12.7922 23.9994 13.0001 23.9994C13.208 23.9994 13.4107 23.9346 13.5801 23.814C13.8841 23.599 21.0291 18.44 21.0001 12C21.0001 7.589 17.4111 4 13.0001 4C8.58909 4 5.00009 7.589 5.00009 11.995C4.97109 18.44 12.1161 23.599 12.4201 23.814ZM13.0001 6C16.3091 6 19.0001 8.691 19.0001 12.005C19.0211 16.443 14.6121 20.428 13.0001 21.735C11.3891 20.427 6.97909 16.441 7.00009 12C7.00009 8.691 9.69109 6 13.0001 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.9300325eef279651dc5d42427b61a509.svg";
export { ForwardRef as ReactComponent };